import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/:chatId?/:isAsideExpanded?/:isDiscoverExpanded?/:inviteId?',
    name: 'Home',
    component: Home
  },
  {
    path: '/sign-in',
    name: 'Sign In',
    component: () => import('../views/SignIn.vue')
  },
  {
    path: '/sign-up',
    name: 'Sign Up',
    component: () => import('../views/SignUp.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/Privacy.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
